import React from 'react';

import { IonSearchbar, IonToolbar } from '@ionic/react';

import { useScreenDispatch, useScreenState } from 'components/Screen';
import { useAutoFocus } from 'hooks/useAutoFocus';
import {
  OFFSET,
  SEARCH_QUERY,
  TABLE_SETTINGS,
  initialState,
} from 'scenes/FinancePage/constants';
import { SET_TABLE_SETTINGS } from 'scenes/FinancePage/screenReducer';

const SearchToolbar = ({ onHideToolbar }: any) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const ref = useAutoFocus<HTMLIonSearchbarElement>();

  const handleChange = (ev: Event) => {
    const target = ev.target as HTMLIonSearchbarElement;
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: {
        ...screenState[TABLE_SETTINGS],
        [SEARCH_QUERY]: target.value,
        [OFFSET]: initialState[TABLE_SETTINGS][OFFSET],
      },
    });
  };

  const handleCancel = () => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: {
        ...screenState[TABLE_SETTINGS],
        [SEARCH_QUERY]: undefined,
        [OFFSET]: initialState[TABLE_SETTINGS][OFFSET],
      },
    });
    onHideToolbar();
  };

  return (
    <IonToolbar>
      <IonSearchbar
        value={screenState[TABLE_SETTINGS][SEARCH_QUERY]}
        debounce={1000}
        onIonChange={handleChange}
        onIonCancel={handleCancel}
        animated={true}
        enterkeyhint={'search'}
        inputmode={'numeric'}
        placeholder={'Search by id'}
        showCancelButton={'always'}
        ref={ref}
      />
    </IonToolbar>
  );
};

export default SearchToolbar;
